export default __webpack_public_path__ + "static/media/refreshNew.ab09bfcb.svg";